import type { App } from '@vue/runtime-core'
import hasPermit from '@/directive/has-permit'
import hasRole from '@/directive/has-role'
import clickOutside from '@/directive/click-outside'

//注册自定义指令
export const registerDirective = (app: App) => {
  app.directive('hasPermit', hasPermit)
  app.directive('hasRole', hasRole)
  app.directive('click-outside', clickOutside)
}
